var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9996 6.60001H8.00051C6.57001 6.60528 5.19959 7.17591 4.18806 8.18747C3.17653 9.19903 2.60597 10.5695 2.6007 12V36C2.60597 37.4305 3.17653 38.801 4.18806 39.8126C5.19959 40.8241 6.57001 41.3948 8.00051 41.4H39.9996C41.4318 41.4 42.8053 40.8311 43.8179 39.8184C44.8306 38.8057 45.3995 37.4322 45.3995 36V12C45.3995 10.5678 44.8306 9.19434 43.8179 8.18164C42.8053 7.16894 41.4318 6.60001 39.9996 6.60001ZM5.54062 11.18C5.71245 10.663 6.04231 10.213 6.48371 9.89359C6.92511 9.57419 7.45569 9.40156 8.00051 9.40002H39.9996C40.5479 9.39735 41.0829 9.56804 41.5283 9.88773C41.9737 10.2074 42.3067 10.6597 42.4796 11.18V11.32L42.3596 11.42L23.9601 24.28H23.8601L5.46061 11.4L5.54062 11.18ZM42.5996 36C42.5996 36.6896 42.3257 37.3509 41.8381 37.8385C41.3505 38.3261 40.6892 38.6 39.9996 38.6H8.00051C7.31259 38.5948 6.65438 38.3192 6.16792 37.8327C5.68147 37.3462 5.40584 36.6879 5.40061 36V14.68L23.2001 27.14C23.4379 27.3052 23.7205 27.3937 24.0101 27.3937C24.2996 27.3937 24.5822 27.3052 24.8201 27.14L42.5996 14.68V36Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d5178913d4d495a9406f4d358c4e48c7.svg";
export { ForwardRef as ReactComponent };